import PropTypes from 'prop-types';
import classNames from 'classnames';

import { legacyTheme } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';

import TrayCard from '../Components/TrayCard';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'flex-start',
    margin: '25px auto',
    flexWrap: 'wrap',
    maxWidth: 1100,
    [legacyTheme.breakpoints.match('md')]: {
      flexWrap: 'wrap',
    },
  },
  noMaxWidth: {
    maxWidth: 'none',
  },
  twoColumnsCard: {
    width: '45%',
  },
  twoColumnsLabel: {
    fontSize: 13,
    lineHeight: '22px',
  },
};

const Tray = ({ CardProps, cards, classes, noMaxWidth, onCardClick, twoColumns }) => (
  <div className={classNames(classes.root, { [classes.noMaxWidth]: noMaxWidth })}>
    {cards.map((card, index) => (
      <TrayCard
        key={String(index)}
        classes={
          twoColumns ? { root: classes.twoColumnsCard, label: classes.twoColumnsLabel } : null
        }
        onClick={() => onCardClick(card.slug)}
        {...card}
        {...CardProps}
      />
    ))}
  </div>
);

Tray.propTypes = {
  CardProps: PropTypes.shape({}),
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      imageUrl: srcOrNextImageProp,
      label: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
      tooltip: PropTypes.shape({}),
    }).isRequired
  ).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  noMaxWidth: PropTypes.bool,
  onCardClick: PropTypes.func.isRequired,
  twoColumns: PropTypes.bool,
};

Tray.defaultProps = {
  CardProps: {},
  noMaxWidth: false,
  twoColumns: false,
};

export default withStyles(Tray, styles);
